const populationSources = {
  australia: 'https://www.abs.gov.au/AUSSTATS/abs@.nsf/Latestproducts/3101.0Main%20Features3Sep%202019?opendocument&tabname=Summary&prodno=3101.0&issue=Sep%202019&num=&view=',
  brazil: 'https://www.ibge.gov.br/en/statistics/social/population/18448-estimates-of-resident-population-for-municipalities-and-federation-units.html?=&t=o-que-e',
  canada: 'https://www150.statcan.gc.ca/t1/tbl1/en/tv.action?pid=1710000901',
  chile: 'https://www.leychile.cl/Navegar?idNorma=1107597&idParte=&idVersion=2018-09-06',
  china: 'https://en.wikipedia.org/wiki/Provinces_of_China',
  colombia: 'https://web.archive.org/web/20090310072713/http://www.colombiaya.com/seccion-colombia/division-politica.html',
  germany: 'https://www.destatis.de/DE/Home/_inhalt.html',
  india: 'https://www.censusindia.gov.in/2011census/PCA/PCA_Highlights/pca_highlights_file/India/Chapter-1.pdf',
  italy: 'http://www.tuttitalia.it/regioni/',
  japan: 'http://www.stat.go.jp/english/data/jinsui/2011np/index.html',
  mexico: 'https://web.archive.org/web/20110406225157/http://www.censo2010.org.mx/',
  netherlands: 'https://opendata.cbs.nl/statline/#/CBS/nl/dataset/70072ned/table?dl=3B9A1',
  pakistan: 'http://www.urckarachi.org/downloads/Census%202017%20Population_Results.pdf',
  peru: 'https://www.onpe.gob.pe/',
  spain: 'https://en.wikipedia.org/wiki/Autonomous_communities_of_Spain',
  uk: 'https://www.ons.gov.uk/peoplepopulationandcommunity/populationandmigration/populationestimates/datasets/populationestimatesforukenglandandwalesscotlandandnorthernireland',
  ukraine: 'https://en.wikipedia.org/wiki/Oblasts_of_Ukraine',
}

const populationSourceMap = {
  '036': 'australia',
  '076': 'brazil',
  '124': 'canada',
  '152': 'chile',
  '156': 'china',
  '170': 'colombia',
  '276': 'germany',
  '356': 'india',
  '380': 'italy',
  '392': 'japan',
  '484': 'mexico',
  '528': 'netherlands',
  '586': 'pakistan',
  '604': 'peru',
  '724': 'spain',
  '826': 'uk',
  '804': 'ukraine',
  CA: 'canada',
  AU: 'australia',
  UK: 'uk',
  DE: 'germany',
  IN: 'india',
  BR: 'brazil',
  PK: 'pakistan',
  SP: 'spain',
  IT: 'italy',
  MX: 'mexico',
  JP: 'japan',
  PE: 'peru',
  CO: 'colombia',
  NL: 'netherlands',
  UA: 'ukraine',
  CH: 'chile',
  ZH: 'china',
}

export default function getPopulationSourceLink(regionCode) {
  if (!regionCode) {
    return null
  }
  const codeString = `${regionCode}`
  let code = null
  if (codeString.match(/^[0-9]+$/)) {
    code = codeString
  } else {
    code = codeString.substr(0, 2)
  }
  if (populationSourceMap[code]) {
    const country = populationSourceMap[code]
    if (populationSources[country]) {
      return populationSources[country]
    }
  }
  return null;
}